import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { set_session_expiry_from_response } from '@/utils/auth/session_manager';

function normalize_bool(value) {
  return value === true || value === 'true';
}

export default {
  name: 'UserLogin',

  mixins: [alert_mixin],

  components: {
    OnboardingIndex
  },

  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },

  mounted() {
    const redirect_reason = sessionStorage.getItem('auth_redirect_reason');

    if (redirect_reason) {
      sessionStorage.removeItem('auth_redirect_reason');
      this.show_error(redirect_reason);
    }
  },

  methods: {

    async login_function() {

      if (!this.username || !this.password) {
        this.show_error("Please enter your username and password.");
        return;
      }

      this.verification_running = true;

      try {

        // A new login can happen without a full page reload. Clear Vuex data
        // before installing the new identity so metadata cannot cross users.
        await this.$store.dispatch('resetStore');

        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password
        });

        const response_data =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;

        // Store token
        sessionStorage.setItem("token", response_data.token);
        sessionStorage.setItem("user_id", response_data.user_id);
        sessionStorage.setItem("current_user_id", response_data.user_id);
        sessionStorage.setItem("user_role", response_data.role_type);
        sessionStorage.setItem("current_role", response_data.role_type);
        sessionStorage.setItem("is_aic_one_login", "false");

        set_session_expiry_from_response(response_data);

        // Store user info
        this.$store.dispatch("setCurrentUserId", response_data.user_id);
        this.$store.dispatch("setCurrentLeadId", response_data.lead_id);
        this.$store.dispatch("setCurrentRole", response_data.role_type);
        this.$store.dispatch("setCurrentLeadName", response_data.full_name);
        this.$store.dispatch("setOrganization", response_data.organization || null);
        const is_organization_admin = normalize_bool(response_data.is_organization_admin);
        this.$store.dispatch("setIsOrganizationAdmin", is_organization_admin);
        const is_platform_admin = true;
        this.$store.dispatch("setIsPlatformAdmin", is_platform_admin);
        if (response_data.organization) {
          sessionStorage.setItem("current_organization", JSON.stringify(response_data.organization));
        }
        sessionStorage.setItem(
          "is_organization_admin",
          is_organization_admin ? "true" : "false"
        );
        sessionStorage.setItem(
          "is_platform_admin",
          "true"
        );
        sessionStorage.setItem("admin_first_name", response_data.first_name || "");
        sessionStorage.setItem("admin_last_name", response_data.last_name || "");
        sessionStorage.setItem("admin_email", response_data.email || this.username || "");
        // First-time login flag
        const is_first_time =
          response_data.first_time_login === true ;

        sessionStorage.setItem(
          "first_time_login",
          is_first_time ? "true" : "false"
        );

        // Redirect
        if (is_first_time) {

          this.$router.push({
            path: "/first_time_login/",
            query: {
              user_id: response_data.user_id,
              token: response_data.token
            }
          });

        } else {

          this.$router.push("/one_time_pin");

        }

      } catch (error) {

        this.handle_login_error(error);

      } finally {

        this.verification_running = false;

      }

    },

    handle_login_error(error) {

      const responseData = error?.response?.data;

      if (responseData && typeof responseData === "object") {
        this.show_error(
          responseData.message || "Invalid username or password."
        );
        return;
      }

      this.show_error("Unable to connect to the server.");

    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }

  }
};
